export default "__VITE_ASSET__BYVcEqE7__"